import React from "react";
import { Flower2Icon } from "lucide-react";
import { images } from "../../data/content";
import { CtaButton } from "../ui/CtaButton";
import { Countdown } from "../ui/Countdown";
export function Hero() {
  return <header className="bg-cream px-5 pb-14 pt-8 sm:pt-12" data-id="element-177" data-mp="cut8jtazpf2r">
      <div className="mx-auto max-w-4xl text-center" data-id="element-178" data-mp="huxptljq2du1">
        <div className="flex flex-col items-center gap-3 sm:flex-row sm:justify-center" data-id="element-179" data-mp="hwimbgplk6uj">
          <div className="flex items-center gap-2.5" data-id="element-180" data-mp="mt93y8h1vai2">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand-700 text-white" data-id="element-181" data-mp="qvdugyc7br0h">
              <Flower2Icon className="h-5 w-5" aria-hidden="true" data-id="element-182" data-mp="vlu7wig0vcmu" />
            </span>
            <span className="font-serif text-2xl font-black text-brand-800" data-id="element-183" data-mp="10lfffh99ctb6">
              Reflexology 360°<sup className="text-xs" data-id="element-184" data-mp="15kieml2k45b8">™</sup>
            </span>
          </div>
          <span className="rounded-full border border-brand-200 bg-white px-3.5 py-1.5 text-xs font-bold uppercase tracking-wide text-brand-700" data-id="element-185" data-mp="15ifeh87owvss">
            The Complete Visual Reflexology System
          </span>
        </div>

        <h1 className="mt-7 font-serif text-[2.35rem] font-black leading-[1.08] text-ink sm:text-6xl" data-id="element-186" data-mp="4ozla28rcmfm">
          Organize a Basic Reflexology Session in{" "}
          <em className="italic text-brand-600" data-id="element-187" data-mp="3vvasyh89wlfx">Up to 15 Minutes</em>
        </h1>
        <p className="mt-3 font-serif text-xl font-bold text-brand-800 sm:text-2xl" data-id="element-188" data-mp="3ruqth70895qm">Using One Simple Visual System</p>

        <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-ink/75 sm:text-xl" data-id="element-189" data-mp="sdis0dc5sr5l">
          I created REFLEXOLOGY 360°™ to help you stop jumping between scattered notes, videos, charts, and different
          resources every time you want to study or practice reflexology.
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-3xl" data-id="element-190" data-mp="ekt5m7spxk7y">
        <img src={images.mainMockup} alt="REFLEXOLOGY 360° — 6 volumes, foot and hand maps, study cards, planner and checklists" className="-mx-2 w-[calc(100%+1rem)] max-w-none sm:mx-0 sm:w-full" data-id="element-191" data-mp="1b51tugug5z61" />
      </div>

      <div className="mx-auto mt-6 max-w-2xl rounded-2xl bg-brand-50 p-5 text-center ring-1 ring-brand-100" data-id="element-192" data-mp="30o0ddlq29iem">
        <p className="text-base leading-relaxed text-ink/80 sm:text-lg" data-id="element-193" data-mp="35muu8i4gwww3">
          Inside, you'll get <strong className="text-brand-800" data-id="element-194" data-mp="2qu1d6s9js8pb">6 Premium Volumes</strong> +{" "}
          <strong className="text-brand-800" data-id="element-195" data-mp="2vtmc52opwh21">5 Exclusive Bonuses</strong> + Visual Foot &amp; Hand Maps + Practice
          Protocols + Checklists + Worksheets — all organized in one practical system.
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-xl" data-id="element-196" data-mp="2ms64v3t78v21">
        <CtaButton id="hero-cta" label="Yes! I want Reflexology 360°" data-id="element-197" data-mp="27ybcr9h9jkdj" />
        <p className="mt-3 text-center text-sm text-ink/60" data-id="element-198" data-mp="2cw31jumm2qdi">
          Instant Digital Access · One-Time Payment of <strong className="text-ink" data-id="element-199" data-mp="65deuz8mq1lq">$27</strong> · Lifetime Access ·
          7-Day Guarantee
        </p>
        <Countdown data-id="element-200" data-mp="b585d1ohsp69" />
        <p className="mt-5 text-center text-base text-ink/75" data-id="element-201" data-mp="b3op3b2u6e4h">
          Get REFLEXOLOGY 360°™ today for the special launch price.
          <br data-id="element-202" data-mp="1vkxwsy3elfnx" />
          <strong className="text-brand-800" data-id="element-203" data-mp="1qnxp6iqwo4up">Only $27 — One-time payment</strong>
        </p>
      </div>
    </header>;
}